import React from 'react';
import {Link} from 'react-router-dom';

const Footer = ()=>{
	return (
		<footer className="footer container-fluid">
			<div className="container p-0">
				<div className="row">
					<div className="col-sm-12 col-md-10">
						<div className="my-2">
							Copyright 2018. <strong><Link to="/about-us">Contracts.ph</Link></strong>. All rights reserved. All use of this website is subject to our <Link to="/terms-of-use">Terms of Use</Link>.
						</div>
						<div className="my-2">
							Disclaimer: We supply information and software and cannot provide legal advice, opinions, or recommendations. We are not a law firm or a substitute for an attorney.
						</div>
					</div>
					<div className="col-sm-12 col-md-2 d-flex align-items-center justify-content-end">
						<div className="text-sm-center w-100">
							<a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/contractsph">
								<i className="fa fa-facebook fa-3x" aria-hidden="true"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;


// WEBPACK FOOTER //
// ./src/view/Footer.js